import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import inventoryModule from "@kubdee/module-inventory";

export default createModuleLayout({
  moduleId: MODULES.INVENTORY,
  moduleConfig: inventoryModule,
});
